import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";

import { UnifiedDataTable } from "../../../layout/unified-data-table/ui/unified-data-table";
import type { UnifiedTableRecord } from "../../../shared/ui/data-table/model/data-table-contract";

import * as Styled from "./physician-care-team.styled";

interface IPatientInfoOutletContext {
  setIsStretchContent: React.Dispatch<React.SetStateAction<boolean>>;
}

const physicianCareTeamRecord: UnifiedTableRecord = {
  module: "physician-care-team",
  pageTitle: "Physician Care Team",
  sections: [
    {
      id: "physician-care-team",
      title: "Physician Care Team",
      tables: [
        {
          id: "physician-care-team-table",
          columns: [
            { key: "role", header: "Role", sortable: true },
            { key: "name", header: "Name", sortable: true },
            { key: "specialty", header: "Specialty", sortable: true },
            { key: "phone", header: "Phone", sortable: true },
            { key: "fax", header: "Fax", sortable: true },
            { key: "address", header: "Address", sortable: true },
            { key: "date", header: "Date", sortable: true },
          ],
          rows: [
            {
              role: "Referral/Consult",
              name: "ENT, for evaluation and follow up",
              specialty: "ENT",
              phone: "-",
              fax: "-",
              address: "-",
              date: "04/04/2022",
            },
            {
              role: "Referral/Consult",
              name: "Allergy, for evaluation and follow up",
              specialty: "Allergy and Immunology",
              phone: "-",
              fax: "-",
              address: "-",
              date: "10/15/2017",
            },
            {
              role: "Referral/Consult",
              name: "ENT, for evaluation and follow up",
              specialty: "ENT",
              phone: "-",
              fax: "-",
              address: "-",
              date: "10/15/2017",
            },
            {
              role: "Referral/Consult",
              name: "Pulmonology, for evaluation and follow up",
              specialty: "Pulmonary Diseases",
              phone: "-",
              fax: "-",
              address: "-",
              date: "10/15/2017",
            },
            {
              role: "Referral/Consult",
              name: "Cardiology, for evaluation and follow up",
              specialty: "Cardiology",
              phone: "-",
              fax: "-",
              address: "-",
              date: "08/14/2017",
            },
          ],
          ui: {
            searchable: true,
            searchPlaceholder: "Search...",
            searchKeys: [
              "role",
              "name",
              "specialty",
              "phone",
              "fax",
              "address",
              "date",
            ],
            downloadable: ["csv", "xls", "pdf"],
            showTableDownloads: true,
            defaultRowsPerPage: 10,
            rowsPerPageOptions: [5, 10, 20, 25],
          },
        },
      ],
    },
  ],
};

export const PhysicianCareTeam = () => {
  const outletContext = useOutletContext<
    IPatientInfoOutletContext | undefined
  >();
  const setIsStretchContent = outletContext?.setIsStretchContent;
  const contentScrollerRef = React.useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!setIsStretchContent) {
      return;
    }

    setIsStretchContent(true);

    return () => {
      setIsStretchContent(false);
    };
  }, [setIsStretchContent]);

  return (
    <Styled.Container>
      <Styled.Title>Physician Care Team</Styled.Title>
      <UnifiedDataTable
        record={physicianCareTeamRecord}
        useSharedSectionNav
        scrollContainerRef={contentScrollerRef}
      />
    </Styled.Container>
  );
};
